<template>
  <div v-if="visible">
    <div class="deemed" style="display: block"></div>
    <div class="layer-pop">
      <div class="layer-pop-wrap">
        <h2 class="txt-right"><img src="@/assets/img/layer-close.svg" alt="닫기" @click="close()" /></h2>
        <div class="coach-payment">
          <h1>코칭료 상세</h1>
          <table>
            <tr>
              <th>No</th>
              <th class="w-80px">코칭일</th>
              <th class="w-60px">유형</th>
              <th>이름</th>
              <th>상태</th>
              <th>Pay</th>
            </tr>
            <tr v-for="(item, index) in list" :key="index">
              <td>{{ list.length - (page - 1) * 50 - index }}</td>
              <td>{{ item.startDate }} {{ item.startTime }}~{{ item.endTime }}</td>
              <td>{{ item.sessionType }}</td>
              <td>{{ item.userName }}</td>
              <td>
                <p v-html="item.sessionStatusName"></p>
              </td>
              <td>{{ item.sessionPay | comma }}</td>
            </tr>
            <tr>
              <td colspan="5" class="txt-left">총 코칭료</td>
              <td class="point">{{ totalPay | comma }}</td>
            </tr>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import dayjs from "dayjs";
export default {
  name: "payment_pop",
  props: {
    visible: {
      type: Boolean,
      require: true,
      default: false,
    },
    month: {
      type: String,
      default: "",
    },
  },
  watch: {
    visible: function (newVal) {
      if (newVal == true) {
        this.visible = true;
        this.getPamynetDetail();
      } else {
        this.visible = false;
      }
    },
  },
  data: () => ({
    list: [],
    totalPay: 0,
    page: 1,
  }),
  components: {},
  mounted() {},
  methods: {
    close() {
      this.$emit("close", false);
    },
    getPamynetDetail() {
      let params = {
        month: this.month,
      };
      this.axios
        .get("/front/coarch/paymentCoarchingList", { params })
        .then((res) => {
          if (res.data.success) {
            this.list = res.data.data;
            this.totalPay = 0;
            for (let item of this.list) {
              item.sessionStatusName = item.sessionStatusName.replace("N", "<br>N");
              item.sessionStatusName = item.sessionStatusName.replace("완", "<br>완");
              item.startTime = dayjs(item.startDatetime).format("HH:mm");
              item.endTime = dayjs(item.endDatetime).format("HH:mm");
              item.startDate = dayjs(item.startDatetime).format("YYYY-MM-DD");
              this.totalPay += Number(item.sessionPay);
            }
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>
